import { connect } from "react-redux";
import { sendMessage, getMessages, messagesSeen } from "../../../action_managers/messages";
import DealPage from "./deal_page";
import { fetchDeal, updateDeal } from "../../../action_managers/deals";
import { getBudgetByDealUUID } from "../../../action_managers/budgets";
import { showModal } from "../../../actions/modal";
import { DEAL_REQUEST_MODAL } from "../../modals/modal_root";

const showRequestModal = props => showModal(DEAL_REQUEST_MODAL, props);
export default connect(
  ({ deals, messages, user, budgets }) => ({
    messages,
    user: user.user,
    deals,
    budgets,
  }),
  {
    getMessages,
    sendMessage,
    fetchDeal,
    updateDeal,
    showRequestModal,
    getBudgetByDealUUID,
    messagesSeen,
  }
)(DealPage);
